export const SEARCH_ALLERGENE_FAILURE = 'SEARCH_ALLERGENE_FAILURE';

export const searchAllergeneFailure = ( payload: Error ) => ({
    type: SEARCH_ALLERGENE_FAILURE,
    payload,
    error: true,
});